<template>
  <b-container data-aos="fade-up">
    <h1 class="mt-5 mb-2 text-primary">Privacy Policy</h1>
    <p>
      At the Thorney, Harby and Wigsley Volunteer Car Scheme we regard your
      privacy as important and we comply with the Data Protection Act 1998.
    </p>
    <p>
      We will only use any personal information you send us for the purposes for
      which you provide it.
    </p>
    <p>
      We will only hold your information for as long as necessary for these
      purposes and will not pass it to any other parties unless this is made
      clear to you.
    </p>
    <p>
      All volunteers who have access to your personal data or are associated
      with the handling of that data are obliged to respect the confidentiality
      of your personal data.
    </p>
    <p>
      There is a general right of access to personal data held by Thorney, Harby
      and Wigsley Volunteer Car Scheme and a request can be made for access by
      <b-link to="/contact-us">contacting Clare Welfare</b-link>, the scheme
      co-ordinator.
    </p>
  </b-container>
</template>

<script>
export default {
  name: "Privacy",
};
</script>